import { namespace } from 'vuex-class';
import { Swipe, SwipeItem } from 'vant';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { landData } from '@/shared/utils/landData';
import URLUtils from '@/shared/utils/URLUtils';
import { openThirdPage } from '@/api/native/utils';
import { exchangeStatusEnum, packageEntranceEnum } from '@/api/transfer/types';
import { MembersRightsPrefix, membersRightsUrl } from '@/constant';
import IconSvg from '@/components/Icon-svg';
import { queryOrderToPay } from '@/api/rights/order/order';
import { RightHelper } from '@/shared/right-router-helper';
import { SuperMemberSourceEnum } from '@/api/rights/types';
import { getSkTabInfo, skNativeContainer } from '@/api/native/container';
import { listerBack } from '@/shared/utils/backListener';
import { MemberRouterNameEnum } from '@/shared/right-utils/routerName';
import { RightsBannerType } from '../../types';

import style from './index.module.scss';

const MyProfileStore = namespace('myProfile');

@Component
export default class SwipeBannerNew extends Vue {
  @MyProfileStore.State rightsBanners!: RightsBannerType[];

  @MyProfileStore.Action getPackageOrange!: () => Promise<void>;

  // 待支付订单数量
  private orderNum = 0;

  private async created() {
    const { haveShown } = await getSkTabInfo('my');
    if (await skNativeContainer()) {
      if (haveShown) {
        this.initDataFetch();
      }
      /** 不能自动取消 需要持续监听 */
      /** 监听app容器切换 */
      listerBack(() => {
        this.initDataFetch();
      }, false);
    } else {
      this.initDataFetch();
    }
  }

  private async initDataFetch() {
    await this.getPackageOrange();
    this.bannerItemExpose();
    // 查询待支付订单列表
    queryOrderToPay().then((res) => {
      this.orderNum = res;
    }).catch(() => {
      // 兜底为不展示
      this.orderNum = 0;
    });
  }

  /** 有权益生效 或者待支付的订单展示权益中心模块 */
  private get isVisible(): boolean {
    return (this.rightsBanners && this.rightsBanners.length > 0)
    || !!this.orderNum;
  }


  private bannerItemExpose() {
    if (this.isVisible) {
      this.rightsBanners.map((item) => {
        this.$ubtModuleExposeNew('fincance_me_membershipCenter_expose', {
          supplierCode: item.supplierCode,
          packageType: item.packageType,
        });
        return true;
      });
    }
  }

  private renderSwiper() {
    return (
      <div class={style.swipeContainer}>
        {this.rightsBanners.map((item, index) => (
          <div
            key={index}
            class={style.bannerItem}
            onClick={this.onBannerClick.bind(this, item)}
          >
            <div class={style.title}>{item.title}</div>
            <div class={style.marketContent}>{item.marketContent}</div>
            <div class={style.footer}>去查看</div>
            <img class={style.coverImg} src={item.coverImg} />
          </div>
        ))}
      </div>
    );
  }

  private goRightOrder() {
    openThirdPage(RightHelper.getOrderUrl());
  }

  private render() {
    if (this.isVisible) {
      this.$ubtModuleExposeNew('fincance_me_membershipCenter', {
        // 上报当前待划扣订单数量
        hasorderNum: !!this.orderNum,
      });
    }
    return this.isVisible ? (
      <div class={style.rights}>
        <div class={style.titleWrappr}>
          <div class={style.rightsTitle}>权益中心</div>
          {!!this.orderNum
          && <div class={style.rightsTips}>您有{this.orderNum}笔待支付订单
            <IconSvg
            class={style.dialogClose}
            iconClass="myprofile-right-tips"
            onClick={this.goRightOrder.bind(this)}/>
          </div>
          }
        </div>
        {this.rightsBanners && !!this.rightsBanners.length && this.renderSwiper()}
      </div>
    ) : null;
  }

  private onBannerClick(item: RightsBannerType) {
    this.$ubtPageButtonNew('fincance_me_membershipCenter_click', {
      supplierCode: item.supplierCode,
      packageType: item.packageType,
    });

    if (item.exchangeStatus === exchangeStatusEnum.GRANTED) {
      return;
    }

    /** 如果是臻系列权益 & 臻享卡，直接跳转卡列表页 */
    if ([packageEntranceEnum.ZHEN_SERIES_CARD,
      packageEntranceEnum.CHANNEL_B,
      packageEntranceEnum.SELL_FLOW_ZXK,
    ].includes(item.entranceType)) {
      // const url = URLUtils.changeURLArg(membersRightsUrl,
      //   'source', landData.getSouce());

      const url = URLUtils.formatUrl(membersRightsUrl, {
        source: landData.getSouce(),
        entranceType: item.entranceType,
        from: SuperMemberSourceEnum.MY_PROFILE,
      });
      openThirdPage(url);
    }

    if (item.entranceType === packageEntranceEnum.CHANNEL_ELSE) {
      const url = URLUtils.formatUrl(
        `${MembersRightsPrefix}${
          MemberRouterNameEnum.CHANNEL_ELSE
        }.html#/${
          MemberRouterNameEnum.CHANNEL_ELSE
        }`, {
          source: landData.getSouce(),
          entranceType: item.entranceType,
          from: SuperMemberSourceEnum.MY_PROFILE,
        },
      );
      openThirdPage(url);
    }
  }
}
